// or your router
import { DetailedHTMLProps, HTMLAttributes } from "react";
import { ExtraProps } from "react-markdown";

import AppTypography from "../../Text/AppTypography";
import { MarkdownElCommonProps } from "../MarkdownRenderer";

export type MarkdownParagraphElProps = DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
> &
  ExtraProps &
  MarkdownElCommonProps;

/** <p></p> element. */
export function MarkdownParagraphEl({
  isUseDefaultMargins,
  sx,
  node,
  children,
  ...otherProps
}: MarkdownParagraphElProps) {
  return (
    <AppTypography
      sx={{ ...(isUseDefaultMargins && { mb: 1.5 }), ...sx }}
      component='p'
      // variant='body1'
      isInheritFontStyle
      {...otherProps}
    >
      {children}
    </AppTypography>
  );
}
